import { Globe } from 'lucide-react';

// Renders a real country flag image (flagcdn.com) from an ISO 3166-1 alpha-2 code.
export const CountryFlag = ({ code, className = '', width = 24 }) => {
  if (!code) {
    return <Globe style={{ width, height: width }} className={`text-muted-foreground ${className}`} />;
  }
  const cc = code.toLowerCase();
  return (
    <img
      src={`https://flagcdn.com/w40/${cc}.png`}
      srcSet={`https://flagcdn.com/w80/${cc}.png 2x`}
      width={width}
      alt={`${code} flag`}
      loading="lazy"
      className={`inline-block object-cover rounded-sm shadow-sm ring-1 ring-black/5 ${className}`}
      style={{ width, height: 'auto', aspectRatio: '4 / 3' }}
    />
  );
};

export default CountryFlag;
